import {Component, OnInit} from '@angular/core';
import {CommonService} from '../../services/common.service';

@Component({
  selector: 'app-left-side-navigation',
  templateUrl: './left-side-navigation.component.html',
  styleUrls: ['./left-side-navigation.component.scss']
})
export class LeftSideNavigationComponent implements OnInit {
  public menuItems: any;

  constructor(private commonService: CommonService) {
  }

  ngOnInit(): void {
    this.menuItems = [
      {name: 'Domov', icon: 'fas fa-home', link: '', headerName: 'Vyhľadávanie'},
    ];
  }

  public updateHeader(headerName: string): void {
    this.commonService.currentPage.next(headerName);
  }
}
